import BadgesValueV2 from "../BadgesValueV2";
import DiscussionsBadgeRequirements from "./DiscussionsBadgeRequirements";

export default class DiscussionsBadgesValue extends BadgesValueV2 {
  public requirements: DiscussionsBadgeRequirements =
    new DiscussionsBadgeRequirements();
}
